import * as UnitDivide from "../unit-divide";
import { Watt, BtuPerHour } from "./power";
import { SquareMeter, SquareFeet } from "./area";
import { DeltaCelsius, DeltaFahrenheit } from "./delta-temperature";
// Thermal Transmittance
export var WattPerSquareMeterPerKelvin = UnitDivide.intensityByDeltaTemperature("WattPerSquareMeterPerKelvin", UnitDivide.powerByArea("", Watt, SquareMeter), DeltaCelsius);
export var BtuPerHourPerSquareFeetPerFahrenheit = UnitDivide.intensityByDeltaTemperature("BtuPerHourPerSquareFeetPerFahrenheit", UnitDivide.powerByArea("", BtuPerHour, SquareFeet), DeltaFahrenheit);
//# sourceMappingURL=thermal-transmittance.js.map